export const pestTypeList = [
  {
    Description:
      "Standing dead trees which have died since the last survey. This implies that if an aerial survey is flown annually that each year the new dead trees will be detected and mapped.",
    Category: "Mortality",
    Type: "Pest",
    DamageImageURL: "/images/1546017-PPT.jpg",
    Title: "View of killed pine trees by southern pine beetles",
    SubTitle: "Ronald F. Billings,Texas A&M Forest Service, Bugwood.org",
  },
  {
    Description:
      "Standing dead trees which have died since the last survey. This implies that if an aerial survey is flown annually that each year the new dead trees will be detected and mapped.",
    Category: "Mortality",
    Type: "Pest",
    DamageImageURL: "/images/5171038-PPT.jpg",
    Title: "Typical damage seen after an infestation of emerald ash borer",
    SubTitle: "Daniel Herms, The Ohio State University, Bugwood.org",
  },
  {
    Description:
      "Standing dead trees which have died since the last survey. This implies that if an aerial survey is flown annually that each year the new dead trees will be detected and mapped.",
    Category: "Mortality",
    Type: "Pest",
    DamageImageURL: "/images/5490379-PPT.jpg",
    Title:
      "Transition area where lodgepole pine and ponderosa pine intersect and are both attacked by mountain pine beetle",
    SubTitle: "Whitney Cranshaw, Colorado State University, Bugwood.org",
  },
  {
    Description:
      "Damage which results in physical or functional removal of foliage, partially or wholly by some agent.",
    Category: "Defoliation",
    Type: "Pest",
    DamageImageURL: "/images/0488006-PPT.jpg",
    Title: "Defoliation damage on bald cypress",
    SubTitle: "John Ghent, John Ghent, Bugwood.org",
  },
  {
    Description:
      "Damage which results in physical or functional removal of foliage, partially or wholly by some agent.",
    Category: "Defoliation",
    Type: "Pest",
    DamageImageURL: "/images/1470012-PPT.jpg",
    Title: "Heavy defoliation from spruce budworm",
    SubTitle: "A. Steven Munson, USDA Forest Service, Bugwood.org",
  },
  {
    Description:
      "Damage which results in physical or functional removal of foliage, partially or wholly by some agent.",
    Category: "Defoliation",
    Type: "Pest",
    DamageImageURL: "/images/5540001-PPT.jpg",
    Title: "Aspen defoliation, cause undetermined",
    SubTitle:
      "William M. Ciesla, Forest Health Management International, Bugwood.org",
  },

  {
    Description:
      "Discoloration, dieback, topkill, branch breakage, main stem broken or uprooted, branch flagging, and other types of damage.",
    Category: "Other",
    Type: "Pest",
    DamageImageURL: "/images/1241653-PPT.jpg",
    Title:
      "Root disease is often easily recognized from afar; changes in tree density and clusters of young trees or brush assocaiated with tree mortality are good indicators of root disease",
    SubTitle: "Robert L. James, USDA Forest Service, Bugwood.org",
  },
  {
    Description:
      "Discoloration, dieback, topkill, branch breakage, main stem broken or uprooted, branch flagging, and other types of damage.",
    Category: "Other",
    Type: "Pest",
    DamageImageURL: "/images/1441122-PPT.jpg",
    Title: "Wind damage",
    SubTitle:
      "USDA Forest Service - Region 2 - Rocky Mountain Region , USDA Forest Service, Bugwood.org",
  },
  {
    Description:
      "Discoloration, dieback, topkill, branch breakage, main stem broken or uprooted, branch flagging, and other types of damage.",
    Category: "Other",
    Type: "Pest",
    DamageImageURL: "/images/5043015-PPT.jpg",
    Title:
      "Major crown failure caused by codominant branches and included bark",
    SubTitle: "Joseph OBrien, USDA Forest Service, Bugwood.org",
  },
];

export default pestTypeList;
